import {
  kuaishouDetail,
  kuaishouDetailEdit,
  kuaishouDetailEdit2,
  kuaishouSalePropRule,
  kuaishouCategoryProps,
  kuaishouPropsValues,
  kuaishouBatchUpdateCategory,
  kuaishouDetailSupplier,
  saveBatchTempConf,
  KSConfirmPriceStock,
  batchPublishItem,
  getPlatFormBrandList,
  refreshPlatFormBrand,
  applyToOtherShop,
  batchBrandFill,
  batchApplyBrandToShops,
} from '@/api/prod/center'
import store from '@/store'
import Vue from 'vue';

// 过滤上传失败或为空的图片
export function _filterInvalidImg (imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
} 

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications1: JSON.stringify(item.skuSpecifications1 ? item.skuSpecifications1 : [])
      } : {
        ...item,
        skuSpecifications1: item.skuSpecifications1 ? JSON.parse(item.skuSpecifications1) : []
      }
    })
  }

  return isRequest ? {
    ...r,
    theDayOfDeliverGoodsTime: (r.theDayOfDeliverGoodsTime !== -1 && r.theDayOfDeliverGoodsTime) ? r.theDayOfDeliverGoodsTime * 86400 : -1,
    itemPropValues: JSON.stringify(r.itemPropValues ? r.itemPropValues : []),
    imageUrls: JSON.stringify(r.imageUrls ? _filterInvalidImg(r.imageUrls) : []),
    detailImageUrls: JSON.stringify(r.detailImageUrls ? _filterInvalidImg(r.detailImageUrls) : []),
    specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    whiteBaseImageUrl: r.whiteBaseImageUrl?.length ? r.whiteBaseImageUrl.join('|') : '',
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    servicePromise: JSON.stringify(r.servicePromise ? r.servicePromise : {}),
    mainImages34: JSON.stringify(r.mainImages34 ? _filterInvalidImg(r.mainImages34) : []),
    shopBrandConf: JSON.stringify(r.shopBrandConf ? r.shopBrandConf : []),
  } : {
    ...r,
    theDayOfDeliverGoodsTime: (r.theDayOfDeliverGoodsTime !== -1 && r.theDayOfDeliverGoodsTime) ? r.theDayOfDeliverGoodsTime / 86400 : -1,
    itemPropValues: r.itemPropValues ? JSON.parse(r.itemPropValues) : [],
    imageUrls: r.imageUrls ? JSON.parse(r.imageUrls) : [],
    detailImageUrls: r.detailImageUrls ? JSON.parse(r.detailImageUrls) : [],
    specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
    servicePromise: r.servicePromise ? JSON.parse(r.servicePromise) : {},
    whiteBaseImageUrl: r.whiteBaseImageUrl ? r.whiteBaseImageUrl.split('|') : [],
    mainImages34: r.mainImages34 ? JSON.parse(r.mainImages34) : [],
    shopBrandConf: r.shopBrandConf ? JSON.parse(r.shopBrandConf) : [],
  }
}

// 编辑详情
export function editKsDetail(data) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  return kuaishouDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
export function editKsDetail2(data,expandParams) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  let params = _formatGoodsItem(data, true)
  params = {
    itemInfo:{...params},
    ...expandParams
  }
  return kuaishouDetailEdit2(params).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getKsDetail(baseItemId) {
  return kuaishouDetail({
    baseItemId
  }).then(res => {
    if (res.result === 1) {
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}
// 获取详情资料(供销商小店版)
export function getKsDetailSupplier(params) {
  return kuaishouDetailSupplier(params).then(res => {
    if (res.result === 1) {
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}

// 查询类目属性
export function getCategoryProps(data) {
  let _shopId = store.getters.shops_getCategoryPropShopId('kuaishou')
  let _data = {
    ...data,
    shopId: data.shopId ? data.shopId : _shopId // 默认店铺
  }
  if(!_data.shopId) {
    Vue.prototype.$message.error('没有已授权的店铺！');
    return false
  }
  return kuaishouCategoryProps(_data).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
export function getBrandList(data) {
  return getPlatFormBrandList(data, '/kuaishou/brandList').then(res => {
    if (res.result === 1) {
      return res.data || []
    } else {
      return []
    }
  })
}
export function refreshBrand(data) {
  return refreshPlatFormBrand(data, '/kuaishou/refreshBrand').then(res => res.result === 1)
}
// 一键应用到其他店铺
export function ApplyToOtherShop(data) {
  return applyToOtherShop(data).then(res => {
    return res.data || [];
  })
}
// 批量填充品牌信息
export function getShopsBrandFill(data) {
  return batchBrandFill(data, '/kuaishou/batchBrandFill').then(res => {
    return res.data || [];
  })
}

// 批量修改类目
export function getSalePropRule(data) {
  return kuaishouSalePropRule(data).then(res => {
    if (res.result === 1) {
      return res.data || {}
    } else {
      return {}
    }
  })
}

// 查询类目属性值
export function getCategoryPropsValue(data) {
  const limit = 100; // 每页100个
  const cursor = (data.page - 1) * limit
  let _shopId = store.getters.shops_getCategoryPropShopId('kuaishou')
  let _data = {
    categoryId: data.categoryId,
    propId: data.propId,
    propValue: data.propValue,
    cursor,
    limit,
    shopId: data.shopId ? data.shopId : _shopId // 默认店铺
  }
  if(!_data.shopId) {
    Vue.prototype.$message.error('没有已授权的店铺！');
    return false
  }
  return kuaishouPropsValues(_data).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

// 批量修改类目
export function batchKsCategory(data) {
  return kuaishouBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 针对批量铺货设置保存
export const saveBatchTempConfKuaishou = (data) => {
  return saveBatchTempConf({data,platform:'kuaishou/batchPublish'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
export const confirmPriceStockKuaishou = (data) => {
  return KSConfirmPriceStock({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
// 批量铺货
export const batchPublishItemKuaishou = (data) => {
  return batchPublishItem({data,platform:'kuaishou/batchPublish'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
// 批量获取商品品牌
export const ksBatchApplyBrandToShops = (data) => {
  return batchApplyBrandToShops({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}